export const NOT_PURCHASABLE_STATUS: string[] = ['SOLD_OUT', 'NOT_PURCHASABLE', 'NOT_DELIVERABLE'];
